<app-page-header [breadcrumbs]="breadcrumbs" />

<div class="py-4">
  @if (loading()) {
    <div class="flex min-h-[60vh] flex-col items-center justify-center gap-6">
      <app-greentripper-loader size="2xl" [circleMode]="true" [delay]="300" />
      @if (verifyingPayment()) {
        <p class="text-gray-600">{{ 'contribute.payment.verifying' | transloco }}</p>
      } @else if (checkingPaymentStatus()) {
        <p class="text-gray-600">{{ 'contribute.payment.checkingStatus' | transloco }}</p>
      } @else if (redirectingToStripe()) {
        <p class="text-gray-600">{{ 'contribute.payment.redirectingToStripe' | transloco }}</p>
      } @else {
        <p class="text-gray-600">{{ 'contribute.payment.loading' | transloco }}</p>
      }
    </div>
  } @else if (error()) {
    <div class="mx-auto max-w-2xl rounded-lg bg-red-50 p-6 text-center">
      <p class="text-red-600">{{ error() }}</p>
      <button
        pButton
        class="mt-4"
        (click)="navigateToTravelBoard()"
      >
        Retour aux voyages
      </button>
    </div>
  } @else if (wizardService.contributionResult()) {
    <app-contribution-success />
  } @else {
    <div class="mx-auto rounded-lg bg-white p-6 shadow-sm md:max-w-3xl lg:max-w-4xl xl:max-w-6xl 2xl:w-[1500px]">
      @if (hasIncompleteAddress()) {
        <div class="flex flex-col items-center gap-6 rounded-lg bg-greyscale-50 py-12">
          <i class="pi pi-map-marker rounded-full bg-primary-100 p-4"
             style="font-size: 2rem; color: var(--color-primary-500)"></i>
          <div class="flex flex-col items-center gap-2 px-4">
            <h4 class="text-lg font-semibold text-primary-900">
              {{ 'contribute.missingAddress.title' | transloco }}
            </h4>
            <p class="max-w-md text-center text-sm text-greyscale-500">
              {{ 'contribute.missingAddress.description' | transloco }}
            </p>
          </div>
          <a routerLink="/home/account/company">
            <p-button
              [label]="'contribute.missingAddress.goToSettings' | transloco"
              icon="pi pi-cog"
              variant="outlined"
            />
          </a>
        </div>
      } @else {
        @if (paymentCanceled()) {
          <div class="mb-6 flex items-center justify-between rounded-lg border border-amber-200 bg-amber-50 p-4">
            <div class="flex items-center gap-3">
              <i class="pi pi-exclamation-triangle text-xl text-amber-600"></i>
              <p class="text-amber-800">{{ 'contribute.payment.canceled' | transloco }}</p>
            </div>
            <button
              pButton
              icon="pi pi-times"
              severity="secondary"
              [text]="true"
              (click)="dismissCanceledMessage()"
              aria-label="Dismiss message"
            ></button>
          </div>
        }
        <p-stepper [value]="currentStep()" [linear]="true">
        <p-step-list>
          <p-step [value]="1">{{ 'contribute.steps.chooseProject' | transloco }}</p-step>
          <p-step [value]="2">{{ 'contribute.steps.adjustContribution' | transloco }}</p-step>
          <p-step [value]="3">{{ 'contribute.steps.certificateDetails' | transloco }}</p-step>
          <p-step [value]="4">{{ 'contribute.steps.reviewConfirm' | transloco }}</p-step>
        </p-step-list>
        <p-step-panels>
          <p-step-panel [value]="1">
            <ng-template #content let-activateCallback="activateCallback">
              <app-step-choose-project
                [projects]="projects()"
                [loading]="projectsLoading()"
                (next)="onStepChange(2); activateCallback(2)"
              />
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="2">
            <ng-template #content let-activateCallback="activateCallback">
              <app-step-adjust-contribution
                (back)="onStepChange(1); activateCallback(1)"
                (next)="onStepChange(3); activateCallback(3)"
              />
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="3">
            <ng-template #content let-activateCallback="activateCallback">
              <app-step-certificate-details
                (back)="onStepChange(2); activateCallback(2)"
                (next)="onStepChange(4); activateCallback(4)"
              />
            </ng-template>
          </p-step-panel>

          <p-step-panel [value]="4">
            <ng-template #content let-activateCallback="activateCallback">
              <app-step-review-confirm
                [submitting]="submitting()"
                (back)="onStepChange(3); activateCallback(3)"
                (submitForm)="onSubmit()"
              />
            </ng-template>
          </p-step-panel>
        </p-step-panels>
      </p-stepper>
      }
    </div>
  }
</div>
